import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useUserStore = create(
  persist(
    (set, get) => ({
      userId: null,
      userName: null,
      token: null,

      setUser: (userId, userName, token) => set({ userId, userName, token }),

      clearUser: () => set({ userId: null, userName: null, token: null }),

      isAuthenticated: () => {
        const { userId, userName, token } = get();
        return userId !== null && userName !== null && token !== null;
      },
    }),
    {
      name: 'user-storage',
    }
  )
);
